<script lang="ts">
    import {getContext, setContext} from "svelte";
    import defaultCustomize from "../helper/defaultCustomize";
    import type {Message} from "../@type";

    export let messages: Message[];
    export let rootClass: string = "message_list"

    const custom = getContext("custom") || defaultCustomize;

    let selectedId;

    function select(message: Message) {
        selectedId = message.id;
        selectMessageStore.set(messages.find(message=> message.id === selectedId))
    }

    function editEnd(e) {
        if(e.type === "edit-cancel"){
            messages[messages.findIndex(message=> message.id === selectedId)] = e.detail;
        } else if(e.type === "edit-delete") {
            messages.splice(messages.findIndex(message=> message.id === selectedId), 1);
            messages = messages;
        }
        selectedId = null;
        selectMessageStore.set(null);
    }


    import IconList from "../form/IconList.svelte";
    import {createEmptyMessage} from "../@type";
    import selectMessageStore from "../store/selectMessageStore";

    const { open } = getContext('simple-modal');
    export const showModel = () => {
        open(IconList, {mode: "select"}, {}, {onClose: () => messages = messages});
    }

    function newMessage() {
        const message = createEmptyMessage();
        messages[messages.length] = message;
        selectedId = message.id;
    }
</script>
<div class={rootClass}>
    {#each messages as message, index (message.id)}
        {@const replyMessageId = messages.length - 1 === index ? messages[0].id : null}
        {#if selectedId === message.id && custom.editable(message)}
            <svelte:component this="{custom.formSelector(message)}" editingMessage={message} on:edit-enter={editEnd} on:edit-cancel={editEnd} on:icon-click={showModel} on:reply={newMessage}/>
        {:else}
            <svelte:component this="{custom.messageSelector(message)}" message={message} {replyMessageId} on:click={select(message)} on:reply={newMessage}/>
        {/if}
    {/each}
</div>